/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Tim Porritt
 * Created: 03/03/22
 */

import { chakra } from '@chakra-ui/react';
import ChakraSVGPath from '@/components/Charts/ChakraSVG/ChakraSVGPath';

const ChakraSVGText = chakra('text');
const ChakraSVGTextSpan = chakra('tspan');
const ChakraSVGGroup = chakra('g');
const ChakraSVGLine = chakra('line');

export { ChakraSVGPath, ChakraSVGText, ChakraSVGTextSpan, ChakraSVGGroup, ChakraSVGLine };
